/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Breadcrumb, Button, Card, Input, Tooltip, message } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { style } from '../../Styles';
import CustomTableComponentsPageable from '../Global/CustomTableComponentsPageable';
import {
	changeFleetOperatorStatus,
	deleteFleetOperator,
	getAllFleetOperators,
	getAllFleetOperatorsByAdmin,
} from '../../redux/fleetOperatorSlice';
import FleetOperatorDrawer from './FleetOperatorDrawer';
import { formatEnumValue } from '../../Utils/ArrayToObject';
import ActionButtonWithChangeStatus from '../Global/ActionButtonWithChangeStatus';

const FleetOperator = () => {
	const [makingApiCall, setMakingApiCall] = useState(false);
	const [search, setSearch] = useState('');
	const searchTimerRef = useRef(null);
	const { fleetOperator } = useSelector((state) => state.fleetOperator);
	const [displayDrawer, setDisplayDrawer] = useState(false);
	const [selectedFleet, setSelectedFleet] = useState(null);
	const { auth } = useSelector((state) => state.auth);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [sortBy, setSortBy] = useState('name');
	const [sortDirection, setSortDirection] = useState('ASC');

	const showDrawer = () => {
		setDisplayDrawer(true);
	};
	const onCloseDrawer = () => {
		setDisplayDrawer(false);
		setSelectedFleet(null);
	};
	const dispatch = useDispatch();
	const data = fleetOperator?.fleetOperatorList
		? Object.values(fleetOperator.fleetOperatorList)
		: [];

	const fetchAllFlletOperators = () => {
		setMakingApiCall(true);
		const isSuperAdmin = auth?.profile?.role?.includes('SUPER_ADMIN');
		const params = { page: currentPage - 1, size: pageSize, search, sortBy, sortDirection };
		const thunk = isSuperAdmin ? getAllFleetOperators(params) : getAllFleetOperatorsByAdmin(params);
		dispatch(thunk)
			.unwrap()
			.then(() => { })
			.catch(() => {
				message.error('Error getting fleet operators');
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	};

	const handleTableChange = (_, __, sorter, extra) => {
		if (extra?.action !== 'sort') return;
		if (sorter.order) {
			setSortBy(sorter.columnKey || sorter.field);
			setSortDirection(sorter.order === 'ascend' ? 'ASC' : 'DESC');
		} else {
			setSortBy('name');
			setSortDirection('ASC');
		}
		setCurrentPage(1);
	};

	useEffect(() => {
		fetchAllFlletOperators();
	}, [currentPage, pageSize, search, sortBy, sortDirection]);

	const handleDelete = (record, calbback) => {
		setMakingApiCall(true);
		// check if the fleet operator is not missing any required fields
		if (
			record?.vatNumber &&
			record?.contactName &&
			record?.contactSurname &&
			record?.contactEmail &&
			record?.contactPhone
		) {
			dispatch(deleteFleetOperator(record.id))
				.unwrap()
				.then(() => {
					message.success('Fleet operator deleted successfully');
					calbback();
				})
				.catch(() => { })
				.finally(() => {
					onCloseDrawer();
					setMakingApiCall(false);
				});
		} else {
			message.error('Fleet operator is missing required fields');
			setMakingApiCall(false);
		}
	};
	const handleSelectedFleet = (selectedRecord) => {
		setSelectedFleet(selectedRecord);
		showDrawer();
	};
	const columns = [
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
			sorter: true,
		},

		{
			title: 'Type',
			key: 'type',
			render: (record) => {
				return (
					<div style={{ textAlign: 'center' }}>
						<span style={{ ...style.tags, textAlign: 'center' }}>{`${formatEnumValue(
							record?.type,
						)} `}</span>
					</div>
				);
			},
			sorter: true,
		},
		{
			title: 'VAT Number',
			dataIndex: 'vatNumber',
			key: 'vatNumber',
			sorter: true,
		},
		{
			title: 'ID Card Number',
			dataIndex: 'idCardNumber',
			key: 'idCardNumber',
			width: 170,
			ellipsis: true,
			sorter: true,
		},
		{
			title: 'Contact Name',
			dataIndex: 'contactName',
			key: 'contactName',
			sorter: true,
		},
		{
			title: 'Contact Surname',
			dataIndex: 'contactSurname',
			key: 'contactSurname',
			sorter: true,
		},
		{
			title: 'Contact Email',
			dataIndex: 'contactEmail',
			key: 'contactEmail',
			sorter: true,
		},
		{
			title: 'Contact Phone',
			dataIndex: 'contactPhone',
			key: 'contactPhone',
			sorter: true,
		},
		/* {
			title: 'IBAN',
			dataIndex: 'iban',
			key: 'iban',
		}, */
		/* {
			title: 'BIC/SWIFT Code',
			dataIndex: 'bicSwiftCode',
			key: 'bicSwiftCode',
		}, */
		{
			title: 'Status',
			key: 'active',
			render: (record) => {
				return (
					<span style={style.dataContainer}>
						{record.active ? (
							<div style={style.statusActif}>Active</div>
						) : (
							<div style={style.statusInactif}>Inactive</div>
						)}
					</span>
				);
			},
			width: 90,
		},
		auth?.profile?.role?.includes('SUPER_ADMIN') ? {
			title: 'Actions',
			key: 'actions',
			width: 80,
			render: (text, record) => (
				<ActionButtonWithChangeStatus
					record={record}
					onDelete={() => handleDelete(record, () => { })}
					onEdit={() => handleSelectedFleet(record)}
					onRowClick={() => handleSelectedFleet(record)}
					onChangeStatus={() => handleChangeStatus(record)}
				/>
			),
		} : {}
	];

	const handleChangeStatus = (record) => {
		setMakingApiCall(true);
		// check if the fleet operator is not missing any required fields
		if (
			record?.vatNumber &&
			record?.contactName &&
			record?.contactSurname &&
			record?.contactEmail &&
			record?.contactPhone
		) {
			dispatch(
				changeFleetOperatorStatus({
					id: record.id,
					active: !record.active,
				}),
			)
				.unwrap()
				.then(() => {
					message.success('Fleet Operator status updated successfully');
				})
				.catch(() => {
					message.error('Error updating Fleet Operator status');
				})
				.finally(() => {
					setMakingApiCall(false);
				});
		} else {
			message.error(
				'You cannot activate this Fleet Operator since it is missing some required fields',
			);
			setMakingApiCall(false);
		}
	};

	return (
		<>
			<Card
				style={{
					margin: 16,
					maxHeight: '90%', // Set maximum width
					height: 'auto', // Allow width to be dynamic
				}}>
				<div style={style.inlineContent}>
					<div
						style={{
							display: 'flex',
							alignContent: 'center',
							alignItems: 'center',
							float: 'left',
							marginBottom: 8,
						}}>
						<Breadcrumb
							style={{ margin: '0 3em 0 0', fontSize: '1.1em' }}
							items={[
								{
									title: 'Fleet Operators',
								},
							]}
						/>
						<Button
							type='default'
							size='small'
							// style={{ margin: '0 8px 8px 0' }}
							onClick={() => fetchAllFlletOperators()}>
							<ReloadOutlined />
						</Button>
					</div>
					<div
						style={{
							...style.inlineContent,
							float: 'right',
							marginBottom: 8,
						}}>
						<Input.Search
							placeholder='Search'
						allowClear
						style={{ margin: '0 8px 8px 0' }}
					onSearch={(value) => { if (searchTimerRef.current) clearTimeout(searchTimerRef.current); setSearch(value); setCurrentPage(1); }}
					onChange={(e) => { const val = e.target.value; if (searchTimerRef.current) clearTimeout(searchTimerRef.current); searchTimerRef.current = setTimeout(() => { setSearch(val); setCurrentPage(1); }, 400); }}
					/>
						{
							auth?.profile?.role?.includes('SUPER_ADMIN') && <Tooltip
								title={
									data.some(
										(fo) =>
											!fo?.vatNumber ||
											!fo?.contactName ||
											!fo?.contactSurname,
									)
										? 'Unable to add a fleet operator until all required fields for the existing operator are filled.'
										: 'Create a new Fleet Operator'
								}>
								<Button
									disabled={data.some(
										(fo) =>
											!fo?.vatNumber ||
											!fo?.contactName ||
											!fo?.contactSurname,
									)}
									type='default'
									style={{ float: 'right', marginBottom: 8 }}
									onClick={showDrawer}>
									Add Fleet Operator
								</Button>
							</Tooltip>
						}
					</div>
				</div>
				<CustomTableComponentsPageable
					isMakingApiCall={makingApiCall}
					columns={columns}
					dataArray={data}
					handleDoubleClickRow={(record) => auth?.profile?.role?.includes('SUPER_ADMIN') ? handleSelectedFleet(record) : {}}
					handleSelectedRow={() => { }}
					onTableChange={handleTableChange}
					pagination={{
						current: currentPage,
						pageSize,
						total: fleetOperator?.total || 0,
						onChange: (page, size) => {
							setCurrentPage(page);
							setPageSize(size);
						},
					}}
				/>
			</Card>
			{displayDrawer && (
				<FleetOperatorDrawer
					onClose={onCloseDrawer}
					fleetId={selectedFleet?.id}
					handleDelete={handleDelete}
				/>
			)}
		</>
	);
};

export default FleetOperator;
